function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/*********************************************************************************

 ENCRYPT MODULE v.2

 This is a general encryption class that permits on-chain exchange of cryptographic
 secrets, enabling users to communicate with encrypted messages over the blockchain.

 For N > 2 channels, we avoid Diffie-Hellman exchanges *for now* in order to have
 something that is fast to setup, and simply default to having the initiating user
 provide the secret, but only communicating it to members with whom he/she already
 has a shared-secret.

 This module thus does two things:

 1. create Diffie-Hellman key exchanges (2 parties)
 2. distribute keys for Groups using DH-generated keys

 The keys as well as group members / shared keys are saved in the keychain class,
 where they are generally available for any Saito application to leverage.

 UPDATE 17-7-23: We had incomplete key exchanges that couldn't be rectified because on
 party would just return out instead of responding to a re-request.

 *********************************************************************************/
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var Transaction = require('../../lib/saito/transaction')["default"];
var Encrypt = /*#__PURE__*/function (_ModTemplate) {
  function Encrypt(app) {
    var _this;
    _classCallCheck(this, Encrypt);
    _this = _callSuper(this, Encrypt, [app]);
    _this.app = app;
    _this.name = 'Encrypt';
    _this.slug = 'encrypt';
    _this.description = 'A Diffie-Hellman encryption tool for Saito';
    _this.categories = 'Encryption Utilities';
    _this["class"] = 'utility';
    _this.status = 'prod';
    app.connection.on('encrypt-key-exchange', function (publicKey) {
      console.log('initiating key exchange...');
      _this.initiate_key_exchange(publicKey, 0);
      salert('Please be patient as this may take some time');
    });
    app.connection.on('encrypt-decryption-failed', function (publicKey) {
      var key = app.keychain.returnKey(publicKey, true);
      if (key && key !== null && key !== void 0 && key.aes_secret) {
        siteMessage("Your encrypted channel with ".concat(publicKey, " is broken"), 10000);
        app.keychain.addKey(publicKey, {
          encryption_failure: true
        });
      }
    });
    app.connection.on('encrypt-reset-key-exchange', function (publicKey) {
      siteMessage("Resetting key exchange with ".concat(publicKey), 30000);
      _this.reset_key_exchange(publicKey);
    });
    app.connection.on('encrypt-key-exchange-confirm', function (data) {
      var member_array = data.members;
      var msg = "Your wallet has generated new secret keys for secure correspondence with your new contact\n             -- ".concat(app.keychain.returnUsername(member_array[0]), ". \n\n               Unless you backup your wallet you may lose these keys. Do you want help backing up your wallet?");
      _this.app.connection.emit('saito-backup-render-request', {
        msg: msg,
        title: 'NEW FRIEND ADDED'
      });
    });
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Encrypt, _ModTemplate);
  return _createClass(Encrypt, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var keys, _iterator, _step, key;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Encrypt, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                //Clear mistaken broken encryption notices...
                keys = app.keychain.returnKeys();
                _iterator = _createForOfIteratorHelper(keys);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    key = _step.value;
                    delete key.encryption_failure;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "respondTo",
    value: function respondTo(type, obj) {
      var encrypt_self = this;
      if (type == 'user-menu') {
        if (obj !== null && obj !== void 0 && obj.publicKey) {
          if (this.app.keychain.hasSharedSecret(obj.publicKey) || obj.publicKey == encrypt_self.publicKey) {
            return null;
          }
        }
        return {
          text: 'Add Contact',
          icon: 'fa-solid fa-user-lock',
          callback: function callback(app, publicKey) {
            encrypt_self.app.keychain.saveKeys();
            encrypt_self.initiate_key_exchange(publicKey, 0);
            salert('Requesting keys to establish an encrypted channel, please be patient as this may take some time');

            //      encrypt_self.app.connection.emit("stun-create-peer-connection", ([publicKey]));
            //
            // TODO - remove if above works
            //
            //let stun_mod = app.modules.returnModule("Stun");
            //stun_mod.createStunConnectionWithPeers([public_key]);
          }
        };
      }
      return _superPropGet(Encrypt, "respondTo", this, 3)([type]);
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(blk, tx, conf) {
        var sender, receiver, txmsg, request;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (Number(conf) == 0) {
                console.log('ENCRYPT ONCONF: ', tx);
                if (tx.isTo(this.publicKey)) {
                  sender = tx.from[0].publicKey;
                  receiver = tx.to[0].publicKey;
                  txmsg = tx.returnMessage();
                  request = txmsg.request; // "request"
                  //
                  // key exchange requests
                  //
                  if (txmsg.request == 'key exchange request') {
                    if (sender == this.publicKey) {
                      console.log('ENCRYPT: You have sent an encrypted channel request to ' + receiver);
                    }
                    if (receiver == this.publicKey) {
                      console.log('ENCRYPT: You have received an encrypted channel request from ' + sender);
                      this.accept_key_exchange(tx);
                    }
                  }

                  //
                  // key confirm requests
                  //
                  if (txmsg.request == 'key exchange confirm') {
                    if (sender !== this.publicKey) {
                      console.log("ENCRYPT: ".concat(sender, " has accepted your encrypted channel request"));
                      this.confirm_key_exchange(txmsg.bob, sender);
                    } else {
                      console.log('ENCRYPT: You have accepted an encrypted channel request from ' + sender);
                    }
                  }
                  if (txmsg.request == 'diffie hellman reset') {
                    console.log('ENCRYPTION RESET!');
                    this.app.keychain.updateEncryptionByPublicKey(sender, 'reset');
                  }
                }
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onConfirmation(_x2, _x3, _x4) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var _message$request;
        var newtx,
          peer,
          mycallback,
          message,
          tx,
          sender,
          receiver,
          txmsg,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              newtx = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
              peer = _args3.length > 2 ? _args3[2] : undefined;
              mycallback = _args3.length > 3 ? _args3[3] : undefined;
              if (!(newtx == null)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, 0);
            case 1:
              message = newtx.returnMessage();
              if (message !== null && message !== void 0 && (_message$request = message.request) !== null && _message$request !== void 0 && _message$request.includes('diffie hellman')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, _superPropGet(Encrypt, "handlePeerTransaction", this, 3)([app, newtx, peer, mycallback]));
            case 2:
              console.log(message);
              tx = new Transaction(undefined, message.data);
              sender = tx.from[0].publicKey;
              receiver = tx.to[0].publicKey;
              txmsg = tx.returnMessage();
              if (message.request === 'diffie hellman key exchange') {
                //
                // key exchange requests
                //
                if (txmsg.request == 'key exchange request') {
                  if (receiver == this.publicKey) {
                    console.log('\n\n\nYou have accepted an encrypted channel request from ' + sender);
                    this.accept_key_exchange(tx, 1, peer);
                  }
                }
              }
              if (message.request === 'diffie hellman key response') {
                this.confirm_key_exchange(txmsg.bob, sender);
              }
              if (message.request === 'diffie hellman key reset') {
                console.log('ENCRYPTION RESET!');
                this.app.keychain.updateEncryptionByPublicKey(sender, 'reset');
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handlePeerTransaction(_x5) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "onPeerHandshakeComplete",
    value: function () {
      var _onPeerHandshakeComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var _iterator2, _step2, key;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(app.BROWSER == 0)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              //
              // Try again for partial key exchanges!
              //
              _iterator2 = _createForOfIteratorHelper(this.app.keychain.returnKeys());
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  key = _step2.value;
                  if ((key.aes_privatekey || key.aes_publicKey) && !key.aes_secret) {
                    console.log('ENCRYPT: attempt key exchange again for: ' + key.publicKey);
                    this.initiate_key_exchange(key.publicKey, 1);
                  }
                }

                //
                // check if we have a diffie-key-exchange with peer
                //
                //if (peer.peer.publicKey != "") {
                //  if (!app.keychain.hasSharedSecret(peer.peer.publicKey)) {
                //  this.initiate_key_exchange(peer.peer.publicKey, 1, peer);  // offchain diffie-hellman with server
                //  }
                //}
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerHandshakeComplete(_x6, _x7) {
        return _onPeerHandshakeComplete.apply(this, arguments);
      }
      return onPeerHandshakeComplete;
    }()
  }, {
    key: "reset_key_exchange",
    value: function () {
      var _reset_key_exchange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(recipient) {
        var tx;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(recipient);
            case 1:
              tx = _context5.v;
              if (tx) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              console.log("".concat(recipient, " is sending me encrypted messages!"));
              tx.msg = {
                module: this.name,
                request: 'diffie hellman reset'
              };
              _context5.n = 3;
              return tx.sign();
            case 3:
              this.app.network.propagateTransaction(tx);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function reset_key_exchange(_x8) {
        return _reset_key_exchange.apply(this, arguments);
      }
      return reset_key_exchange;
    }()
    /**
     *
     *  Step 1 -- request a key exchange
     *
     *  recipients can be a string (single address) or an array (multiple addresses)
     */
  }, {
    key: "initiate_key_exchange",
    value: function () {
      var _initiate_key_exchange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(recipients) {
        var offchain,
          peer,
          recipient,
          parties_to_exchange,
          tx,
          alice,
          alice_publicKey,
          alice_privatekey,
          i,
          _args6 = arguments,
          _t;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              offchain = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 0;
              peer = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
              recipient = '';
              parties_to_exchange = 2;
              if (Array.isArray(recipients)) {
                if (recipients.length > 0) {
                  recipients.sort();
                  recipient = recipients[0];
                  parties_to_exchange = recipients.length;
                }
              } else {
                recipient = recipients;
                parties_to_exchange = 2;
              }
              if (recipient) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              tx = null;
              _context6.p = 2;
              _context6.n = 3;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(recipient, BigInt(0)
              //BigInt(parties_to_exchange * this.app.wallet.default_fee)
              );
            case 3:
              tx = _context6.v;
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t = _context6.v;
              console.log('error: ' + _t);
            case 5:
              if (tx) {
                _context6.n = 7;
                break;
              }
              console.log('zero fee tx creating...');
              _context6.n = 6;
              return this.app.wallet.createUnsignedTransaction(recipient, BigInt(0), BigInt(0));
            case 6:
              tx = _context6.v;
            case 7:
              alice = this.app.crypto.createDiffieHellman();
              alice_publicKey = alice.getPublicKey(null, 'compressed').toString('hex');
              alice_privatekey = alice.getPrivateKey(null, 'compressed').toString('hex');
              this.app.keychain.updateEncryptionByPublicKey(recipient, alice_publicKey, alice_privatekey, '');
              tx.msg.module = this.name;
              tx.msg.request = 'key exchange request';
              tx.msg.alice_publicKey = alice_publicKey;
              tx.addTo(this.publicKey);

              //
              // does not currently support n > 2
              //
              if (parties_to_exchange > 2) {
                for (i = 1; i < parties_to_exchange; i++) {
                  tx.addTo(recipients[i]);
                }
              }
              _context6.n = 8;
              return tx.sign();
            case 8:
              if (!(offchain == 0)) {
                _context6.n = 10;
                break;
              }
              _context6.n = 9;
              return this.app.network.propagateTransaction(tx);
            case 9:
              _context6.n = 11;
              break;
            case 10:
              this.app.connection.emit('relay-send-message', {
                recipient: recipients,
                request: 'diffie hellman key exchange',
                data: tx.toJson()
              });
            case 11:
              return _context6.a(2);
          }
        }, _callee6, this, [[2, 4]]);
      }));
      function initiate_key_exchange(_x9) {
        return _initiate_key_exchange.apply(this, arguments);
      }
      return initiate_key_exchange;
    }()
    /**
     * Step 2 -- We have been asked to exchange keys
     */
  }, {
    key: "accept_key_exchange",
    value: function () {
      var _accept_key_exchange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(tx) {
        var offchain,
          peer,
          txmsg,
          remote_address,
          our_address,
          alice_publicKey,
          fee,
          bob,
          bob_publicKey,
          bob_privatekey,
          bob_secret,
          newtx,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              offchain = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 0;
              peer = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
              txmsg = tx.returnMessage();
              console.log('Encrypt: Accepting key exchange');
              remote_address = tx.from[0].publicKey;
              our_address = tx.to[0].publicKey;
              alice_publicKey = txmsg.alice_publicKey;
              if (this.app.BROWSER == 1) {
                siteMessage("".concat(this.app.keychain.returnUsername(remote_address), " has added you as a friend"), 5000);
              }
              fee = BigInt(tx.to[0].amount);
              bob = this.app.crypto.createDiffieHellman();
              bob_publicKey = bob.getPublicKey(null, 'compressed').toString('hex');
              bob_privatekey = bob.getPrivateKey(null, 'compressed').toString('hex');
              bob_secret = bob.computeSecret(Buffer.from(alice_publicKey, 'hex')); //this.app.crypto.createDiffieHellmanSecret(bob, Buffer.from(alice_publicKey, "hex"));
              _context7.n = 1;
              return this.app.wallet.createUnsignedTransaction(remote_address, BigInt(0), BigInt(fee));
            case 1:
              newtx = _context7.v;
              if (!(newtx == null)) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              newtx.msg.module = 'Encrypt';
              newtx.msg.request = 'key exchange confirm';
              newtx.msg.tx_id = tx.id; // reference id for parent tx
              newtx.msg.bob = bob_publicKey;
              newtx.addTo(our_address);
              _context7.n = 3;
              return newtx.sign();
            case 3:
              if (!(offchain == 0)) {
                _context7.n = 5;
                break;
              }
              _context7.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              _context7.n = 6;
              break;
            case 5:
              //let data = {};
              //data.module = "Encrypt";
              //data.tx = newtx;
              //this.app.network.sendPeerRequest("diffie hellman key response", data, peer);
              console.log('Encrypt: sending response on network');
              this.app.connection.emit('relay-send-message', {
                recipient: remote_address,
                request: 'diffie hellman key response',
                data: newtx.toJson()
              });
            case 6:
              this.app.keychain.updateEncryptionByPublicKey(remote_address, bob_publicKey.toString('hex'), bob_privatekey.toString('hex'), bob_secret.toString('hex'));
              this.app.keychain.addWatchedPublicKey(remote_address);
              this.sendEvent('encrypt-key-exchange-confirm', {
                members: [remote_address, our_address]
              });
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function accept_key_exchange(_x0) {
        return _accept_key_exchange.apply(this, arguments);
      }
      return accept_key_exchange;
    }()
    /**
     * Step 3
     * Process the returned key from the counterparty
     */
  }, {
    key: "confirm_key_exchange",
    value: function () {
      var _confirm_key_exchange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(bob, sender) {
        var bob_publicKey, senderkeydata, alice_publicKey, alice_privatekey, alice, alice_secret;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              bob_publicKey = Buffer.from(bob, 'hex');
              senderkeydata = this.app.keychain.returnKey(sender, true);
              if (!(senderkeydata == null)) {
                _context8.n = 1;
                break;
              }
              if (!(this.app.BROWSER == 1)) {
                _context8.n = 1;
                break;
              }
              alert('Cannot find original diffie-hellman keys for key-exchange');
              return _context8.a(2);
            case 1:
              if (this.app.BROWSER == 1) {
                siteMessage("Successfully added ".concat(this.app.keychain.returnUsername(sender), " as a friend"), 5000);
              }
              this.app.connection.emit('saito-whitelist', {
                address: sender,
                duration: 0
              });
              alice_publicKey = Buffer.from(senderkeydata.aes_publicKey, 'hex');
              alice_privatekey = Buffer.from(senderkeydata.aes_privatekey, 'hex');
              alice = this.app.crypto.createDiffieHellman(alice_publicKey, alice_privatekey);
              alice_secret = alice.computeSecret(bob_publicKey); //this.app.crypto.createDiffieHellmanSecret(alice, bob_publicKey);
              this.app.keychain.updateEncryptionByPublicKey(sender, alice_publicKey.toString('hex'), alice_privatekey.toString('hex'), alice_secret.toString('hex'));
              this.app.keychain.addWatchedPublicKey(sender);

              //
              //
              // Create chat group contact
              this.sendEvent('encrypt-key-exchange-confirm', {
                members: [sender, this.publicKey]
              });
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function confirm_key_exchange(_x1, _x10) {
        return _confirm_key_exchange.apply(this, arguments);
      }
      return confirm_key_exchange;
    }()
  }]);
}(ModTemplate);
module.exports = Encrypt;